import script from "./TopNavigator.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopNavigator.vue?vue&type=script&lang=ts&setup=true"

import "./TopNavigator.vue?vue&type=style&index=0&id=26e89a10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26e89a10"]])

export default __exports__